<ng-container>
  <div class="api-store-content">
    <div class="api-store-content-apis">
      <app-acor-card></app-acor-card>
    </div>
  </div>
</ng-container>
